export default {
  'are-you-sure' : {
    en : 'Are you sure?',
    th : 'คุณแน่ใจหรือไม่?',
    fr : 'Êtes-vous sûr ?',
    pt : 'Você tem certeza?',
    km : 'តើអ្នកប្រាកដទេ?',
    pl : 'Czy jesteś pewien?'
  },
  'cancel': {
    en : 'Cancel',
    th : 'ยกเลิก',
    fr : 'Annuler',
    pt : 'Cancelar',
    km : 'បោះបង់',
    pl : 'Anuluj'
  },
  'player': {
    en : 'Player',
    th : 'ผู้เล่น',
    fr : 'Joueur',
    pt : 'Jogador',
    km : 'អ្នកលេង',
    pl : 'Gracz'
  },
  'customiser': {
    en : 'Customiser',
    th : 'ปรับแต่ง',
    fr : 'Personnaliser',
    pt : 'Personalizar',
    km : 'កែតម្រូវ',
    pl : 'Dostosuj'
  },
  'add-new': {
    en : 'Add New',
    th : 'เพิ่มใหม่',
    fr : 'Ajouter nouveau',
    pt : 'Adicionar novo',
    km : 'បន្ថែមថ្មី',
    pl : 'Dodaj nowy'
  },
  'copy-existing': {
    en : 'Copy Existing',
    th : 'คัดลอกที่มีอยู่',
    fr : 'Copier existant',
    pt : 'Copiar existente',
    km : 'ចម្លងដែលមានស្រាប់',
    pl : 'Kopiuj istniejące'
  },
  'thai': {
    en : 'Thai',
    th : 'ไทย',
    fr : 'Thaï',
    pt : 'Tailandês',
    km : 'ភាសាថៃ',
    pl : 'Tajski'
  },
  'ok' : {
    en : 'OK',
    th : 'โอเค',
    fr : 'OK',
    pt : 'OK',
    km : 'យល់ព្រម',
    pl : 'OK'
  },
  'select-question-type' : {
    en : 'Select Question Type',
    th : 'เลือกประเภทคำถาม',
    fr : 'Sélectionnez le type de question',
    pt : 'Selecione o tipo de pergunta',
    km : 'ជ្រើសរើសប្រភេទសំណួរ',
    pl : 'Wybierz typ pytania'
  },
  'matching-question' : {
    en : 'Matching Question',
    th : 'คำถามเรียงคู่',
    fr : 'Question d’association',
    pt : 'Pergunta de correspondência',
    km : 'សំណួរត្រូវគ្នា',
    pl : 'Pytanie dopasowujące'
  },
  'rearrange-question' : {
    en : 'Rearrange Question',
    th : 'คำถามเรียงลำดับ',
    fr : 'Question de réorganisation',
    pt : 'Pergunta de reorganização',
    km : 'សំណួររៀបចំឡើងវិញ',
    pl : 'Pytanie o reorganizację'
  },
  'select-from-pairs-question' : {
    en : 'Select from Pairs Question',
    th : 'เลือกคำถามจากคู่',
    fr : 'Sélectionner parmi les paires',
    pt : 'Selecione de pares',
    km : 'ជ្រើសរើសពីគូសំណួរ',
    pl : 'Wybierz z par'
  },
  'sequence-builder' : {
    en : 'Sequence Builder',
    th : 'สร้างลำดับ',
    fr : 'Générateur de séquences',
    pt : 'Construtor de sequência',
    km : 'អ្នកបង្កើតលំដាប់',
    pl : 'Kreator sekwencji'
  },
  'remove' : {
    en : 'Remove',
    th : 'ลบ',
    fr : 'Supprimer',
    pt : 'Remover',
    km : 'លុបចេញ',
    pl : 'Usuń'
  },
  'select-from-pairs-customizer': {
    en: 'Select from Pairs Customizer',
    th: 'เลือกจากการปรับแต่งคู่',
    fr: 'Personnalisation des paires',
    pt: 'Personalizador de pares',
    km: 'កំណត់រចនាគូសំណួរ',
    pl: 'Dostosuj wybór z par'
  },


  'item-name': {
    en: 'Item Name',
    th: 'ชื่อรายการ',
    fr: 'Nom de l’élément',
    pt: 'Nome do item',
    km: 'ឈ្មោះវត្ថុ',
    pl: 'Nazwa elementu'
  },
  'instructions-optional': {
    en: 'Instructions (optional)',
    th: 'คำสั่ง (ตัวเลือก)',
    fr: 'Instructions (optionnel)',
    pt: 'Instruções (opcional)',
    km: 'ការណែនាំ (ជាជម្រើស)',
    pl: 'Instrukcje (opcjonalne)'
  },
  'instructions' : {
    en : 'Instructions',
    th : 'คำสั่ง',
    fr : 'Instructions',
    pt : 'Instruções',
    km : 'ការណែនាំ',
    pl : 'Instrukcje'
  },
  'submit': {
    en: 'Submit',
    th: 'ส่ง',
    fr: 'Soumettre',
    pt: 'Enviar',
    km: 'ដាក់ស្នើ',
    pl: 'Prześlij'
  },
  'copy': {
    en: 'Copy',
    th: 'คัดลอก',
    fr: 'Copier',
    pt: 'Copiar',
    km: 'ចម្លង',
    pl: 'Kopiuj'
  },
  'enter-id-of-item-to-copy': {
    en: 'Enter Id of Item to Copy',
    th: 'ป้อนรหัสของรายการที่ต้องการคัดลอก',
    fr: 'Entrez l’ID de l’élément à copier',
    pt: 'Digite o ID do item para copiar',
    km: 'បញ្ចូលលេខសម្គាល់វត្ថុដើម្បីចម្លង',
    pl: 'Wprowadź ID elementu do skopiowania'
  },
  'input-is-not-a-valid-uuid': {
    en: 'Input is not a valid uuid',
    th: 'ข้อมูลที่ป้อนไม่ใช่ UUID ที่ถูกต้อง',
    fr: 'L’entrée n’est pas un UUID valide',
    pt: 'A entrada não é um UUID válido',
    km: 'ការបញ្ចូលមិនមែនជា UUID ត្រឹមត្រូវទេ',
    pl: 'Wprowadzona wartość nie jest prawidłowym UUID'
  },
  'input-is-not-of-valid-type': {
    en: 'Input is not of valid type',
    th: 'ข้อมูลที่ป้อนไม่ใช่ประเภทที่ถูกต้อง',
    fr: 'L’entrée n’est pas d’un type valide',
    pt: 'A entrada não é de um tipo válido',
    km: 'ការបញ្ចូលមិនមែនជាប្រភេទត្រឹមត្រូវទេ',
    pl: 'Wprowadzona wartość nie jest prawidłowego typu'
  },
  'item-id': {
    en: 'Item Id',
    th: 'รหัสรายการ',
    fr: 'ID de l’élément',
    pt: 'ID do item',
    km: 'លេខសម្គាល់វត្ថុ',
    pl: 'ID elementu'
  },
  'sequence-customizer': {
    en: 'Sequence Customizer',
    th: 'การปรับแต่งลำดับ',
    fr: 'Personnalisation de séquence',
    pt: 'Personalizador de sequência',
    km: 'កំណត់រចនាលំដាប់',
    pl: 'Dostosuj sekwencję'
  },
  'sequence-name': {
    en: 'Sequence Name',
    th: 'ชื่อลำดับ',
    fr: 'Nom de la séquence',
    pt: 'Nome da sequência',
    km: 'ឈ្មោះលំដាប់',
    pl: 'Nazwa sekwencji'
  },
  'drag-on-items-to-add': {
    en: 'Drag on Items to Add',
    th: 'ลากรายการเพื่อเพิ่ม',
    fr: 'Glissez les éléments à ajouter',
    pt: 'Arraste os itens para adicionar',
    km: 'អូសវត្ថុដើម្បីបន្ថែម',
    pl: 'Przeciągnij elementy, aby dodać'
  },
  'unsupported-type': {
    en: 'Unsupported Type',
    th: 'ประเภทไม่รองรับ',
    fr: 'Type non pris en charge',
    pt: 'Tipo não suportado',
    km: 'ប្រភេទមិនត្រូវបានគាំទ្រ',
    pl: 'Nieobsługiwany typ'
  },
  'rearrange-column-customizer': {
    en: 'Rearrange Column Customizer',
    th: 'การปรับแต่งคอลัมน์ใหม่',
    fr: 'Personnalisation de colonne réorganisée',
    pt: 'Personalizador de coluna reorganizada',
    km: 'កំណត់រចនាជួរឈរឡើងវិញ',
    pl: 'Dostosuj kolumnę do reorganizacji'
  },
  'add-image': {
    en: 'Add Image',
    th: 'เพิ่มรูปภาพ',
    fr: 'Ajouter une image',
    pt: 'Adicionar imagem',
    km: 'បន្ថែមរូបភាព',
    pl: 'Dodaj obraz'
  },
  'add-audio': {
    en: 'Add Audio',
    th: 'เพิ่มเสียง',
    fr: 'Ajouter un audio',
    pt: 'Adicionar áudio',
    km: 'បន្ថែមអូឌីយ៉ូ',
    pl: 'Dodaj dźwięk'
  },
  'add-by-text-or-by-id': {
    en: 'Add by Text or by Id',
    th: 'เพิ่มโดยข้อความหรือโดยรหัส',
    fr: 'Ajouter par texte ou par ID',
    pt: 'Adicionar por texto ou por ID',
    km: 'បន្ថែមតាមអត្ថបទ ឬតាមលេខសម្គាល់',
    pl: 'Dodaj według tekstu lub ID'
  },


  'finished': {
    en : 'Finished',
    th : 'สิ้นสุด',
    fr : 'Terminé',
    pt : 'Concluído',
    km : 'បានបញ្ចប់',
    pl : 'Zakończono'
  },
  'finish': {
    en : 'Finish',
    th : 'เสร็จ',
    fr : 'Finir',
    pt : 'Finalizar',
    km : 'បញ្ចប់',
    pl : 'Zakończ'
  },
  'next': {
    en : 'Next',
    th : 'ต่อไป',
    fr : 'Suivant',
    pt : 'Próximo',
    km : 'បន្ទាប់',
    pl : 'Następny'
  },
  'correct': {
    en : 'Correct',
    th : 'ถูกต้อง',
    fr : 'Correct',
    pt : 'Correto',
    km : 'ត្រឹមត្រូវ',
    pl : 'Poprawny'
  },
  'incorrect': {
    en : 'Incorrect',
    th : 'ไม่ถูกต้อง',
    fr : 'Incorrect',
    pt : 'Incorreto',
    km : 'មិនត្រឹមត្រូវ',
    pl : 'Niepoprawny'
  },
  'upload-warning': {
    en : 'Upload Warning',
    th : 'คำเตือนการอัปโหลด',
    fr : 'Avertissement de téléversement',
    pt : 'Aviso de upload',
    km : 'ការព្រមានអំពីការផ្ទុកឡើង',
    pl : 'Ostrzeżenie dotyczące przesyłania'
  },
  'long-upload-warning-html-text': {
    en : 'Use small assets to ensure smooth rendering of your items.<br><br>For images, aim for around 20-50 KB.<br><br>For audio, aim for around 20-50 KB for short instructions (~5 sec) and 100-300 KB for longer instructions (~30 sec).<br><br>Uploads larger than 300 KB should be rare. Uploads larger than 1 MB will be rejected.',
    th : 'ใช้ส่วนประกอบขนาดเล็กเพื่อให้การแสดงผลของรายการของคุณเรียบร้อย.<br><br>สำหรับภาพ หมายเลขที่เหมาะสมคือประมาณ 20-50 KB.<br><br>สำหรับเสียง หมายเลขที่เหมาะสมคือประมาณ 20-50 KB สำหรับคำแนะนำสั้นๆ (~5 វិនាទី) និង 100-300 KB សម្រាប់ការណែនាំវែង (~30 វិនាទី).<br><br>ការផ្ទុកឡើងដែលមានទំហំលើស 300 KB គួរតែមានកម្រណាស់ ហើយការផ្ទុកឡើងលើស 1 MB នឹងត្រូវបានបដិសេធ។',
    fr : 'Utilisez de petites ressources pour assurer un rendu fluide de vos éléments.<br><br>Pour les images, visez environ 20-50 KB.<br><br>Pour l’audio, visez environ 20-50 KB pour les instructions courtes (~5 s) et 100-300 KB pour les instructions longues (~30 s).<br><br>Les téléversements supérieurs à 300 KB devraient être rares. Les téléversements supérieurs à 1 MB seront rejetés.',
    pt : 'Use arquivos pequenos para garantir uma renderização suave de seus itens.<br><br>Para imagens, mantenha em torno de 20-50 KB.<br><br>Para áudio, em torno de 20-50 KB para instruções curtas (~5 s) e 100-300 KB para instruções longas (~30 s).<br><br>Uploads maiores que 300 KB devem ser raros. Uploads maiores que 1 MB serão rejeitados.',
    km : 'ប្រើទ្រព្យសម្បត្តិតូចៗ ដើម្បីធានាថាការបង្ហាញអត្ថបទរបស់អ្នកមានភាពរលូន។<br><br>សម្រាប់រូបភាព គោលដៅប្រហែល 20-50 KB។<br><br>សម្រាប់អូឌីយ៉ូ គោលដៅប្រហែល 20-50 KB សម្រាប់ការណែនាំខ្លី (~5 វិនាទី) និង 100-300 KB សម្រាប់ការណែនាំវែង (~30 វិនាទី)។<br><br>ការផ្ទុកឡើងធំជាង 300 KB គួរតែមានកម្រណាស់។ ការផ្ទុកឡើងលើសពី 1 MB នឹងត្រូវបានបដិសេធ។',
    pl : 'Używaj małych zasobów, aby zapewnić płynne wyświetlanie elementów.<br><br>Dla obrazów celuj w około 20-50 KB.<br><br>Dla audio celuj w około 20-50 KB dla krótkich instrukcji (~5 s) i 100-300 KB dla dłuższych instrukcji (~30 s).<br><br>Przesyłania większe niż 300 KB powinny być rzadkie. Przesyłania większe niż 1 MB zostaną odrzucone.'
  },
  'not-uploaded': {
    en : 'Not Uploaded',
    th : 'ไม่ได้อัปโหลด',
    fr : 'Non téléversé',
    pt : 'Não enviado',
    km : 'មិនបានផ្ទុកឡើង',
    pl : 'Nie przesłano'
  },
  'file-is-likely-too-large': {
    en : 'File is likely too large',
    th : 'มีความเป็นไปได้ว่าไฟล์มีขนาดใหญ่เกินไป',
    fr : 'Le fichier est probablement trop volumineux',
    pt : 'O arquivo provavelmente é muito grande',
    km : 'ឯកសារមានទំហំធំពេក',
    pl : 'Plik jest prawdopodobnie zbyt duży'
  },
  'attempted': {
    en : 'Attempted : ',
    th : 'พยายาม : ',
    fr : 'Tentative : ',
    pt : 'Tentativa : ',
    km : 'បានព្យាយាម : ',
    pl : 'Próba : '
  },
  'summary' : {
    en : 'Summary',
    th : 'สรุป',
    fr : 'Résumé',
    pt : 'Resumo',
    km : 'សេចក្តីសង្ខេប',
    pl : 'Podsumowanie'
  },
  'close' : {
    en : 'Close',
    th : 'ปิด',
    fr : 'Fermer',
    pt : 'Fechar',
    km : 'បិទ',
    pl : 'Zamknij'
  },
  'try-again' : {
    en : 'Try again',
    th : 'ลองอีกครั้ง',
    fr : 'Réessayer',
    pt : 'Tente novamente',
    km : 'សាកល្បងម្ដងទៀត',
    pl : 'Spróbuj ponownie'
  },
  'create' : {
    en : 'Create',
    th : 'สร้าง',
    fr : 'Créer',
    pt : 'Criar',
    km : 'បង្កើត',
    pl : 'Utwórz'
  },


  'rearrange-question' : {
    en : 'Order Items Question',
    th : 'คำถามเรื่องรายการสั่งซื้อ',
    fr : 'Question de mise en ordre',
    pt : 'Questão de ordenar itens',
    km : 'សំណួររៀបចំវត្ថុ',
    pl : 'Pytanie o uporządkowanie elementów'
  },
  'matching' : {
    en : 'MATCHING',
    th : 'โยงเส้นจับ',
    fr : 'ASSOCIATION',
    pt : 'CORRESPONDÊNCIA',
    km : 'ការផ្គូផ្គង',
    pl : 'DOPASOWANIE'
  },
  'rearrange-items' : {
    en : 'ORDER ITEMS',
    th : 'เรียง',
    fr : 'ORDONNER LES ÉLÉMENTS',
    pt : 'ORDENAR ITENS',
    km : 'រៀបចំវត្ថុ',
    pl : 'UPORZĄDKUJ ELEMENTY'
  },
  'select-from-pairs' : {
    en : 'SELECT FROM PAIRS',
    th : 'เลือกคำตอบที่ถูกต้อง',
    fr : 'SÉLECTIONNER À PARTIR DE PAIRES',
    pt : 'SELECIONAR DE PARES',
    km : 'ជ្រើសរើសពីគូ',
    pl : 'WYBIERZ Z PAR'
  },
  'sequence' : {
    en : 'SEQUENCE',
    th : 'เรียงลำดับชุด',
    fr : 'SÉQUENCE',
    pt : 'SEQUÊNCIA',
    km : 'លំដាប់',
    pl : 'SEKWENCJA'
  },
  'karel-task&version' : {
    en : 'KAREL TASKS',
    th : 'Karel เต่า',
    fr : 'TÂCHES KAREL',
    pt : 'TAREFAS KAREL',
    km : 'ភារកិច្ច KAREL',
    pl : 'ZADANIA KAREL'
  },
  'customize-items' : {
    en : 'CUSTOMISE ITEMS',
    th : 'ออกแบบการ',
    fr : 'PERSONNALISER LES ÉLÉMENTS',
    pt : 'PERSONALIZAR ITENS',
    km : 'ប្តូរតាមបំណងវត្ថុ',
    pl : 'DOSTOSUJ ELEMENTY'
  },
  'logout' : {
    en : 'LOGOUT',
    th : 'ออก',
    fr : 'DÉCONNEXION',
    pt : 'SAIR',
    km : 'ចាកចេញ',
    pl : 'WYLOGUJ SIĘ'
  },
  'preview' : {
    en : 'PREVIEW',
    th : 'ตัวอย่าง',
    fr : 'APERÇU',
    pt : 'VISUALIZAR',
    km : 'មើលជាមុន',
    pl : 'PODGLĄD'
  },
  'preview-titlecase' : {
    en : 'Preview',
    th : 'ตัวอย่าง',
    fr : 'Aperçu',
    pt : 'Pré-visualizar',
    km : 'មើលជាមុន',
    pl : 'Podgląd'
  },
  'blanks' : {
    en : 'Blanks',
    th : 'ช่องว่าง',
    fr : 'Blancs',
    pt : 'Espaços em branco',
    km : 'កន្លែងទទេ',
    pl : 'Luki'
  },
  'blank' : {
    en : 'Blank',
    th : 'ช่องว่าง',
    fr : 'Vide',
    pt : 'Vazio',
    km : 'ទទេ',
    pl : 'Puste'
  },
  'copied' : {
    en : 'Copied',
    th : 'คัดลอก',
    fr : 'Copié',
    pt : 'Copiado',
    km : 'បានចម្លង',
    pl : 'Skopiowano'
  },
  'login-with-google' : {
    en : 'LOGIN WITH GOOGLE',
    th : 'เข้าสู่ระบบด้วย Google',
    fr : 'SE CONNECTER AVEC GOOGLE',
    pt : 'ENTRAR COM GOOGLE',
    km : 'ចូលប្រើជាមួយ Google',
    pl : 'ZALOGUJ SIĘ PRZEZ GOOGLE'
  },
  'login-with-microsoft' : {
    en : 'LOGIN WITH MICROSOFT',
    th : 'เข้าสู่ระบบด้วย Microsoft',
    fr : 'SE CONNECTER AVEC MICROSOFT',
    pt : 'ENTRAR COM MICROSOFT',
    km : 'ចូលប្រើជាមួយ Microsoft',
    pl : 'ZALOGUJ SIĘ PRZEZ MICROSOFT'
  },
  'login-page-text-pt-1' : {
    en : 'Welcome to the PILA Create App!',
    th : 'ยินดีต้อนรับสู่แอป PILA สร้าง!',
    fr : 'Bienvenue dans l’application PILA Create !',
    pt : 'Bem-vindo ao aplicativo PILA Create!',
    km : 'សូមស្វាគមន៍មកកាន់កម្មវិធី PILA Create!',
    pl : 'Witamy w aplikacji PILA Create!'
  },
  'login-page-text-pt-2' : {
    en : 'If your preferred login Service is not listed, feel free to request assistance at edu.pila@oecd.org',
    th : 'หากบริการเข้าสู่ระบบที่คุณต้องการไม่ได้รับการระบุ โปรดติดต่อขอความช่วยเหลือได้ที่ edu.pila@oecd.org',
    fr : 'Si votre service de connexion préféré n’est pas répertorié, n’hésitez pas à demander de l’aide à edu.pila@oecd.org',
    pt : 'Se o serviço de login de sua preferência não estiver listado, solicite assistência em edu.pila@oecd.org',
    km : 'ប្រសិនបើសេវាកម្មចូលប្រើដែលអ្នកចូលចិត្តមិនមានក្នុងបញ្ជី សូមស្នើសុំជំនួយនៅ edu.pila@oecd.org',
    pl : 'Jeśli Twoja preferowana usługa logowania nie jest wymieniona, poproś o pomoc pod adresem edu.pila@oecd.org'
  },
  'welcome-to-the-pila-customiser' : {
    en : 'Welcome to the PILA Customiser',
    th : 'ยินดีต้อนรับสู่ PILA Item Customiser',
    fr : 'Bienvenue dans le personnalisateur PILA',
    pt : 'Bem-vindo ao personalizador PILA',
    km : 'សូមស្វាគមន៍មកកាន់កម្មវិធីកែតម្រូវ PILA',
    pl : 'Witamy w kreatorze dostosowywania PILA'
  },


  'matching-description' : {
    en : 'Learners match choices from two columns to answer a question. Choices can be images, text, or playable audio.',
    th : 'ผู้เรียนจะจับคำตอบจากสองคอลัมน์เพื่อตอบคำถาม ตัวเลือกสามารถเป็นรูปภาพ ข้อความ หรือไฟล์เสียงที่สามารถเล่นได้',
    fr : 'Les apprenants associent des choix de deux colonnes pour répondre à une question. Les choix peuvent être des images, du texte ou de l’audio.',
    pt : 'Os alunos correspondem opções de duas colunas para responder a uma pergunta. As opções podem ser imagens, texto ou áudio reproduzível.',
    km : 'សិស្សត្រូវផ្គូផ្គងជម្រើសពីជួរឈរ​ពីរ ដើម្បីឆ្លើយសំណួរ។ ជម្រើសអាចជារូបភាព អត្ថបទ ឬសំឡេងដែលអាចចាក់បាន។',
    pl : 'Uczniowie dopasowują odpowiedzi z dwóch kolumn, aby odpowiedzieć na pytanie. Opcje mogą być obrazami, tekstem lub odtwarzanym dźwiękiem.'
  },
  'rearrange-items-description' : {
    en : 'Learners are presented with items (images or text) that are \'out of order\' and move them into the correct order.',
    th : 'ผู้เรียนจะได้รับรายการของสิ่งของ (รูปภาพหรือข้อความ) ที่ \'ไม่เรียงลำดับ\' และจะย้ายมันให้เรียงลำดับให้ถูกต้อง',
    fr : 'Les apprenants reçoivent des éléments (images ou texte) dans le désordre et doivent les remettre dans l’ordre correct.',
    pt : 'Os alunos recebem itens (imagens ou texto) que estão fora de ordem e devem colocá-los na ordem correta.',
    km : 'សិស្សទទួលបានធាតុ (រូបភាព ឬអត្ថបទ) ដែល \'មិនត្រឹមត្រូវ\' ហើយត្រូវរៀបចំវាឡើងវិញតាមលំដាប់ត្រឹមត្រូវ។',
    pl : 'Uczniowie otrzymują elementy (obrazy lub tekst), które są w złej kolejności, i muszą je uporządkować prawidłowo.'
  },
  'select-from-pairs-description' : {
    en : 'Students select from one of two choices, for example A or B, to answer a question. Choices can be text, image, or audio.',
    th : 'นักเรียนจะเลือกจากหนึ่งในสองตัวเลือก เช่น A หรือ B เพื่อตอบคำถาม ตัวเลือกสามารถเป็นข้อความ รูปภาพ หรือเสียงได้',
    fr : 'Les étudiants choisissent entre deux options, par exemple A ou B, pour répondre à une question. Les options peuvent être du texte, une image ou de l’audio.',
    pt : 'Os alunos escolhem entre duas opções, por exemplo A ou B, para responder a uma pergunta. As opções podem ser texto, imagem ou áudio.',
    km : 'សិស្សជ្រើសរើសពីមួយក្នុងចំណោមជម្រើសពីរ ដូចជា A ឬ B ដើម្បីឆ្លើយសំណួរ។ ជម្រើសអាចជាអត្ថបទ រូបភាព ឬសំឡេង។',
    pl : 'Uczniowie wybierają jedną z dwóch opcji, na przykład A lub B, aby odpowiedzieć na pytanie. Opcje mogą być tekstem, obrazem lub dźwiękiem.'
  },
  'sequence-description' : {
    en : 'Students play through a series of questions, one after the other, and receive feedback and a report of success along the way!',
    th : 'นักเรียนจะเล่นผ่านชุดของคำถามต่อเนื่องกัน ต่อหนึ่งคำถามต่อหนึ่ง และได้รับข้อคิดเห็นและรายงานความสำเร็จขณะทาง!',
    fr : 'Les étudiants répondent à une série de questions, l’une après l’autre, et reçoivent des commentaires et un rapport de réussite en cours de route !',
    pt : 'Os alunos passam por uma série de perguntas, uma após a outra, e recebem feedback e um relatório de sucesso ao longo do caminho!',
    km : 'សិស្សឆ្លើយតបតាមលំដាប់សំណួរមួយៗ ហើយទទួលបានមតិយោបល់ និងរបាយការណ៍ជោគជ័យនៅពេលដំណើរ។',
    pl : 'Uczniowie rozwiązują serię pytań, jedno po drugim, i otrzymują informacje zwrotne oraz raport o postępach po drodze!'
  },
  'markdown-with-questions-description' : {
    en : 'Build markdown items including accompanying questions, embedding videos, images, audio and LaTex.',
    th : 'สร้างรายการ markdown รวมถึงความสามารถในการฝังวิดีโอ รูปภาพ เสียง และ LaTex',
    fr : 'Créez des éléments en markdown comprenant des questions, en intégrant des vidéos, images, audio et LaTex.',
    pt : 'Crie itens em markdown incluindo perguntas, incorporando vídeos, imagens, áudio e LaTex.',
    km : 'បង្កើតធាតុ Markdown រួមមានសំណួរ និងបញ្ចូលវីដេអូ រូបភាព សំឡេង និង LaTex។',
    pl : 'Twórz elementy w markdown, w tym pytania, osadzając filmy, obrazy, dźwięk i LaTeX.'
  },
  'markdown-with-questions-lower' : {
    en : 'Markdown with Questions',
    th : 'Markdown พร้อมคำถาม',
    fr : 'Markdown avec questions',
    pt : 'Markdown com perguntas',
    km : 'Markdown មានសំណួរ',
    pl : 'Markdown z pytaniami'
  },
  'see-example' : {
    en : 'see example',
    th : 'ดูตัวอย่าง',
    fr : 'voir un exemple',
    pt : 'ver exemplo',
    km : 'មើលឧទាហរណ៍',
    pl : 'zobacz przykład'
  },
  'create-new' : {
    en : 'create new',
    th : 'สร้างใหม่',
    fr : 'créer nouveau',
    pt : 'criar novo',
    km : 'បង្កើតថ្មី',
    pl : 'utwórz nowe'
  },
  'upload-preview-image' : {
    en : 'Upload Preview Image',
    th : 'อัปโหลดรูปภาพตัวอย่าง',
    fr : 'Téléverser une image d’aperçu',
    pt : 'Enviar imagem de pré-visualização',
    km : 'ផ្ទុករូបភាពជាមុន',
    pl : 'Prześlij obraz podglądu'
  },
  'add-row' : {
    en : 'Add Row',
    th : 'เพิ่มแถว',
    fr : 'Ajouter une ligne',
    pt : 'Adicionar linha',
    km : 'បន្ថែមជួរដេក',
    pl : 'Dodaj wiersz'
  },
  'multiple-choice' : {
    en : 'MULTIPLE CHOICE',
    th : 'ตัวเลือกหลายตัว',
    fr : 'CHOIX MULTIPLES',
    pt : 'MÚLTIPLA ESCOLHA',
    km : 'ជម្រើសច្រើន',
    pl : 'WIELOKROTNY WYBÓR'
  },
  'select-multiple' : {
    en : 'Select Multiple',
    th : 'เลือกหลายตัว',
    fr : 'Sélectionner plusieurs',
    pt : 'Selecionar múltiplos',
    km : 'ជ្រើសរើសច្រើន',
    pl : 'Wybierz wiele'
  },
  'add-choice' : {
    en : 'Add Choice',
    th : 'เพิ่มตัวเลือก',
    fr : 'Ajouter un choix',
    pt : 'Adicionar opção',
    km : 'បន្ថែមជម្រើស',
    pl : 'Dodaj opcję'
  },
  'select-all-that-apply' : {
    en : 'Select All That Apply',
    th : 'เลือกทั้งหมดที่ใช้ได้',
    fr : 'Sélectionner tout ce qui s’applique',
    pt : 'Selecionar todas as opções aplicáveis',
    km : 'ជ្រើសរើសទាំងអស់ដែលអាចអនុវត្តបាន',
    pl : 'Zaznacz wszystko, co pasuje'
  },
  'multiple-choice-description' : {
    en : 'Build multiple choice questions with one or many answers.',
    th : 'สร้างคำถามแบบตัวเลือกหลายข้อที่มีคำตอบหนึ่งหรือหลายคำตอบ',
    fr : 'Créez des questions à choix multiples avec une ou plusieurs réponses.',
    pt : 'Crie perguntas de múltipla escolha com uma ou várias respostas.',
    km : 'បង្កើតសំណួរជម្រើសច្រើនដែលមានចម្លើយមួយឬច្រើន។',
    pl : 'Twórz pytania wielokrotnego wyboru z jedną lub wieloma odpowiedziami.'
  },
  'new-choice' : {
    en : 'New Choice',
    th : 'ตัวเลือกใหม่',
    fr : 'Nouveau choix',
    pt : 'Nova opção',
    km : 'ជម្រើសថ្មី',
    pl : 'Nowa opcja'
  },
  'multiple-choice-question' : {
    en : 'Multiple Choice Question',
    th : 'คำถามแบบหลายตัวเลือก',
    fr : 'Question à choix multiples',
    pt : 'Pergunta de múltipla escolha',
    km : 'សំណួរជម្រើសច្រើន',
    pl : 'Pytanie wielokrotnego wyboru'
  },
  'true-false' : {
    en : 'TRUE/FALSE',
    th : 'เติมคำในช่องว่าง',
    fr : 'VRAI/FAUX',
    pt : 'VERDADEIRO/FALSO',
    km : 'ពិត/មិនពិត',
    pl : 'PRAWDA/FAŁSZ'
  },
  'true-false-description' : {
    en : 'True/False questions require users to determine if a statement is true or false, testing their knowledge and comprehension.',
    th : 'คำถามจริง/เท็จให้ผู้ใช้ตัดสินใจว่าข้อความนั้นเป็นจริงหรือเท็จ ทดสอบความรู้และความเข้าใจของพวกเขา',
    fr : 'Les questions Vrai/Faux demandent aux utilisateurs de déterminer si une affirmation est vraie ou fausse, testant ainsi leurs connaissances et leur compréhension.',
    pt : 'Perguntas de Verdadeiro/Falso exigem que os usuários determinem se uma afirmação é verdadeira ou falsa, testando seus conhecimentos e compreensão.',
    km : 'សំណួរ ពិត/មិនពិត តម្រូវឱ្យអ្នកប្រើកំណត់ថាសេចក្តីថ្លែងការណ៍មួយពិតឬមិនពិត ដើម្បីសាកល្បងចំណេះដឹង និងការយល់ដឹង។',
    pl : 'Pytania Prawda/Fałsz wymagają od użytkowników określenia, czy stwierdzenie jest prawdziwe czy fałszywe, testując ich wiedzę i zrozumienie.'
  },
  'true-false-question' : {
    en : 'True/False Question',
    th : 'คำถามจริง/เท็จ',
    fr : 'Question Vrai/Faux',
    pt : 'Pergunta Verdadeiro/Falso',
    km : 'សំណួរ ពិត/មិនពិត',
    pl : 'Pytanie Prawda/Fałsz'
  },
  'fill-in-the-blank' : {
    en : 'FILL IN THE BLANK',
    th : 'เติมคำในช่องว่าง',
    fr : 'COMPLÉTER LES BLANCS',
    pt : 'PREENCHER A LACUNA',
    km : 'បំពេញចន្លោះទទេ',
    pl : 'UZUPEŁNIJ LUKI'
  },
  'fill-in-the-blank-description' : {
    en : 'Students see text with things missing, and try to fill those in.',
    th : 'นักเรียนจะเห็นข้อความที่ขาดหายไปและพยายามเติมคำให้สมบูรณ์',
    fr : 'Les étudiants voient un texte avec des éléments manquants et essaient de les compléter.',
    pt : 'Os alunos veem um texto com partes faltando e tentam preenchê-las.',
    km : 'សិស្សឃើញអត្ថបទដែលបាត់ខ្លះ ហើយព្យាយាមបំពេញវា។',
    pl : 'Uczniowie widzą tekst z brakującymi elementami i próbują je uzupełnić.'
  },
  'fill-in-the-blank-question' : {
    en : 'Fill in the Blank Question',
    th : 'คำถามเติมคำในช่องว่าง',
    fr : 'Question à compléter',
    pt : 'Pergunta de preencher lacuna',
    km : 'សំណួរបំពេញចន្លោះទទេ',
    pl : 'Pytanie z luką do uzupełnienia'
  },
  'quiz-mode' : {
    en : 'Quiz Mode',
    th : 'โหมดแบบทดสอบ',
    fr : 'Mode Quiz',
    pt : 'Modo Quiz',
    km : 'របៀបប្រលង',
    pl : 'Tryb quizu'
  },
  'forced-motion-mode' : {
    en : 'Forced Motion Mode',
    th : 'โหมดการเคลื่อนไหวบังคับ',
    fr : 'Mode de mouvement forcé',
    pt : 'Modo de movimento forçado',
    km : 'របៀបចលនាបង្ខំ',
    pl : 'Tryb quizu'
  },
  'you-cannot-undo-this' : {
    en : 'You Cannot Undo This!',
    th : 'คุณไม่สามารถยกเลิกสิ่งนี้ได้',
    fr : 'Vous ne pouvez pas annuler cela !',
    pt : 'Você não pode desfazer isso!',
    km : 'អ្នកមិនអាចមិនធ្វើវិញបានទេ!',
    pl : 'Nie możesz tego cofnąć!'
  },
  'keep-working' : {
    en : 'Keep Working',
    th : 'ทำงานต่อไป',
    fr : 'Continuez à travailler',
    pt : 'Continue trabalhando',
    km : 'បន្តធ្វើការ',
    pl : 'Kontynuuj pracę'
  },
  'review-mode-quiz-finished' : {
    en : 'Review Mode, Quiz Finished',
    th : 'โหมดตรวจสอบ แบบทดสอบเสร็จสิ้น',
    fr : 'Mode révision, quiz terminé',
    pt : 'Modo revisão, quiz concluído',
    km : 'របៀបពិនិត្យឡើងវិញ ការប្រលងបានបញ្ចប់',
    pl : 'Tryb przeglądu, quiz zakończony'
  },
  'true' : {
    en : 'True',
    th : 'จริง',
    fr : 'Vrai',
    pt : 'Verdadeiro',
    km : 'ពិត',
    pl : 'Prawda'
  },
  'false' : {
    en : 'False',
    th : 'เท็จ',
    fr : 'Faux',
    pt : 'Falso',
    km : 'មិនពិត',
    pl : 'Fałsz'
  },
  'feedback-if-correct' : {
    en : 'Feedback if Correct',
    th : 'ข้อเสนอแนะถ้าถูกต้อง',
    fr : 'Retour si correct',
    pt : 'Feedback se correto',
    km : 'មតិយោបល់បើត្រឹមត្រូវ',
    pl : 'Informacja zwrotna, jeśli poprawne'
  },
  'feedback-if-incorrect' : {
    en : 'Feedback if Incorrect',
    th : 'ข้อเสนอแนะถ้าไม่ถูกต้อง',
    fr : 'Retour si incorrect',
    pt : 'Feedback se incorreto',
    km : 'មតិយោបល់បើមិនត្រឹមត្រូវ',
    pl : 'Informacja zwrotna, jeśli błędne'
  },
  'markdown-with-questions' : {
    en : 'MARKDOWN WITH QUESTIONS',
    th : 'MARKDOWN พร้อมคำถาม',
    fr : 'MARKDOWN AVEC QUESTIONS',
    pt : 'MARKDOWN COM PERGUNTAS',
    km : 'MARKDOWN មានសំណួរ',
    pl : 'MARKDOWN Z PYTANIAMI'
  },


  'fill-in-the-blank-prompt-placeholder' : {
    en : 'Example question: The closest planet to the sun is ____, and the furthest is ____.',
    th : 'ใส่ข้อความของคุณที่นี่',
    fr : 'Exemple de question : La planète la plus proche du soleil est ____, et la plus éloignée est ____.',
    pt : 'Exemplo de pergunta: O planeta mais próximo do sol é ____, e o mais distante é ____.',
    km : 'សំណួរឧទាហរណ៍៖ ផែនដីដែលនៅជិតព្រះអាទិត្យបំផុតគឺ ____, ហើយដែលឆ្ងាយបំផុតគឺ ____។',
    pl : 'Przykładowe pytanie: Najbliższa słońcu planeta to ____, a najdalsza to ____.'
  },
  'fill-in-the-blank-question-customizer' : {
    en : 'Fill in the Blank Question Customizer',
    th : 'เครื่องมือสร้างและปรับแต่งคำถามแบบเติมคำ',
    fr : 'Personnalisation des questions à compléter',
    pt : 'Personalizador de perguntas de preencher lacunas',
    km : 'កម្មវិធីផ្ទាល់ខ្លួនសំណួរបំពេញចន្លោះទទេ',
    pl : 'Dostosowanie pytań z lukami'
  },
  'feedback': {
    en : 'Feedback',
    th : 'คำติชม',
    fr : 'Retour',
    pt : 'Feedback',
    km : 'មតិយោបល់',
    pl : 'Informacja zwrotna'
  },
  'tags': { 
    en: 'Tags', 
    th: 'แท็ก',
    fr: 'Étiquettes',
    pt: 'Etiquetas',
    km: 'ស្លាក',
    pl: 'Tagi'
  },
  'likert': { 
    en: 'LIKERT', 
    th: 'ไลเคิร์ต',
    fr: 'LIKERT',
    pt: 'LIKERT',
    km: 'LIKERT',
    pl: 'SKALA LIKERTA'
  },
  'likert-question': { 
    en: 'Likert Question', 
    th: 'ไลเคิร์ต',
    fr: 'Question de type Likert',
    pt: 'Pergunta de tipo Likert',
    km: 'សំណួរបែប Likert',
    pl: 'Pytanie w skali Likerta'
  },
  'likert-description': { 
    en: 'Likert Description', 
    th: 'คำอธิบายไลเคิร์ต',
    fr: 'Description de Likert',
    pt: 'Descrição de Likert',
    km: 'ការពិពណ៌នារាង Likert',
    pl: 'Opis Likerta'
  },
  'abstract': { 
    en: 'Abstract', 
    th: 'บทคัดย่อ',
    fr: 'Résumé',
    pt: 'Resumo',
    km: 'សេចក្តីសង្ខេប',
    pl: 'Streszczenie'
  },
  'agreement': { 
    en: 'Agreement', 
    th: 'ข้อตกลง',
    fr: 'Accord',
    pt: 'Acordo',
    km: 'កិច្ចព្រមព្រៀង',
    pl: 'Porozumienie'
  },
  'frequency': { 
    en: 'Frequency', 
    th: 'ความถี่',
    fr: 'Fréquence',
    pt: 'Frequência',
    km: 'ប្រេកង់',
    pl: 'Częstotliwość'
  },
  'satisfaction': { 
    en: 'Satisfaction', 
    th: 'ความพึงพอใจ',
    fr: 'Satisfaction',
    pt: 'Satisfação',
    km: 'ការពេញចិត្ត',
    pl: 'Satysfakcja'
  },
  'happiness': { 
    en: 'Happiness', 
    th: 'ความสุข',
    fr: 'Bonheur',
    pt: 'Felicidade',
    km: 'សុភមង្គល',
    pl: 'Szczęście'
  },
  'positivity': { 
    en: 'Positivity', 
    th: 'ความเป็นบวก',
    fr: 'Positivité',
    pt: 'Positividade',
    km: 'ភាពវិជ្ជមាន',
    pl: 'Pozytywność'
  },
  'likelihood': { 
    en: 'Likelihood', 
    th: 'ความน่าจะเป็น',
    fr: 'Probabilité',
    pt: 'Probabilidade',
    km: 'ប្រូបាប៊ីលីតេ',
    pl: 'Prawdopodobieństwo'
  },
  'poor-to-good': { 
    en: 'Poor to Good', 
    th: 'แย่ถึงดี',
    fr: 'Mauvais à Bon',
    pt: 'Ruim a Bom',
    km: 'អាក្រក់ដល់ល្អ',
    pl: 'Od słabego do dobrego'
  },
  'terrible-to-excellent': { 
    en: 'Terrible to Excellent', 
    th: 'แย่มากถึงยอดเยี่ยม',
    fr: 'Terrible à Excellent',
    pt: 'Terrível a Excelente',
    km: 'អាក្រក់ដល់ល្អឥតខ្ចោះ',
    pl: 'Od okropnego do doskonałego'
  },
  'difficulty': { 
    en: 'Difficulty', 
    th: 'ความยาก',
    fr: 'Difficulté',
    pt: 'Dificuldade',
    km: 'ភាពពិបាក',
    pl: 'Trudność'
  },
  'speed': { 
    en: 'Speed', 
    th: 'ความเร็ว',
    fr: 'Vitesse',
    pt: 'Velocidade',
    km: 'ល្បឿន',
    pl: 'Prędkość'
  },
  'size': { 
    en: 'Size', 
    th: 'ขนาด',
    fr: 'Taille',
    pt: 'Tamanho',
    km: 'ទំហំ',
    pl: 'Rozmiar'
  },


  'never': { 
    en: 'Never', 
    th: 'ไม่เคย',
    fr: 'Jamais',
    pt: 'Nunca',
    km: 'មិនដែល',
    pl: 'Nigdy'
  },
  'rarely': { 
    en: 'Rarely', 
    th: 'แทบจะไม่',
    fr: 'Rarement',
    pt: 'Raramente',
    km: 'កម្រណាស់',
    pl: 'Rzadko'
  },
  'sometimes': { 
    en: 'Sometimes', 
    th: 'บางครั้ง',
    fr: 'Parfois',
    pt: 'Às vezes',
    km: 'ពេលខ្លះ',
    pl: 'Czasami'
  },
  'often': { 
    en: 'Often', 
    th: 'บ่อยครั้ง',
    fr: 'Souvent',
    pt: 'Frequentemente',
    km: 'ញឹកញាប់',
    pl: 'Często'
  },
  'always': { 
    en: 'Always', 
    th: 'เสมอ',
    fr: 'Toujours',
    pt: 'Sempre',
    km: 'ជានិច្ច',
    pl: 'Zawsze'
  },
  'select-likert-category': { 
    en: 'Select Likert Category', 
    th: 'เลือกหมวดหมู่ไลเคิร์ต',
    fr: 'Sélectionner une catégorie Likert',
    pt: 'Selecionar categoria Likert',
    km: 'ជ្រើសប្រភេទ Likert',
    pl: 'Wybierz kategorię Likerta'
  },
  'not-at-all': { 
    en: 'Not at all', 
    th: 'ไม่เลย',
    fr: 'Pas du tout',
    pt: 'De modo nenhum',
    km: 'មិនមានទាំងស្រុង',
    pl: 'Wcale'
  },
  'slightly': { 
    en: 'Slightly', 
    th: 'เล็กน้อย',
    fr: 'Légèrement',
    pt: 'Ligeiramente',
    km: 'បន្តិច',
    pl: 'Nieznacznie'
  },
  'moderately': { 
    en: 'Moderately', 
    th: 'ปานกลาง',
    fr: 'Modérément',
    pt: 'Moderadamente',
    km: 'មធ្យម',
    pl: 'Umiarkowanie'
  },
  'very': { 
    en: 'Very', 
    th: 'มาก',
    fr: 'Très',
    pt: 'Muito',
    km: 'ខ្លាំងណាស់',
    pl: 'Bardzo'
  },
  'extremely': { 
    en: 'Extremely', 
    th: 'อย่างยิ่ง',
    fr: 'Extrêmement',
    pt: 'Extremamente',
    km: 'ខ្លាំងពេក',
    pl: 'Niezwykle'
  },
  'strongly-disagree': { 
    en: 'Strongly Disagree', 
    th: 'ไม่เห็นด้วยอย่างยิ่ง',
    fr: 'Tout à fait en désaccord',
    pt: 'Discordo totalmente',
    km: 'មិនយល់ស្របទាំងស្រុង',
    pl: 'Zdecydowanie się nie zgadzam'
  },
  'disagree': { 
    en: 'Disagree', 
    th: 'ไม่เห็นด้วย',
    fr: 'En désaccord',
    pt: 'Discordo',
    km: 'មិនយល់ស្រប',
    pl: 'Nie zgadzam się'
  },
  'neutral': { 
    en: 'Neutral', 
    th: 'เป็นกลาง',
    fr: 'Neutre',
    pt: 'Neutro',
    km: 'អព្យាក្រឹត',
    pl: 'Neutralny'
  },
  'agree': { 
    en: 'Agree', 
    th: 'เห็นด้วย',
    fr: 'D’accord',
    pt: 'Concordo',
    km: 'យល់ព្រម',
    pl: 'Zgadzam się'
  },
  'strongly-agree': { 
    en: 'Strongly Agree', 
    th: 'เห็นด้วยอย่างยิ่ง',
    fr: 'Tout à fait d’accord',
    pt: 'Concordo totalmente',
    km: 'យល់ព្រមទាំងស្រុង',
    pl: 'Zdecydowanie się zgadzam'
  },
  'very-dissatisfied': { 
    en: 'Very Dissatisfied', 
    th: 'ไม่พอใจมาก',
    fr: 'Très insatisfait',
    pt: 'Muito insatisfeito',
    km: 'មិនពេញចិត្តខ្លាំង',
    pl: 'Bardzo niezadowolony'
  },
  'dissatisfied': { 
    en: 'Dissatisfied', 
    th: 'ไม่พอใจ',
    fr: 'Insatisfait',
    pt: 'Insatisfeito',
    km: 'មិនពេញចិត្ត',
    pl: 'Niezadowolony'
  },
  'satisfied': { 
    en: 'Satisfied', 
    th: 'พอใจ',
    fr: 'Satisfait',
    pt: 'Satisfeito',
    km: 'ពេញចិត្ត',
    pl: 'Zadowolony'
  },
  'very-satisfied': { 
    en: 'Very Satisfied', 
    th: 'พอใจมาก',
    fr: 'Très satisfait',
    pt: 'Muito satisfeito',
    km: 'ពេញចិត្តខ្លាំង',
    pl: 'Bardzo zadowolony'
  },


  'very-unhappy': { 
    en: 'Very Unhappy', 
    th: 'ไม่มีความสุขมาก',
    fr: 'Très malheureux',
    pt: 'Muito infeliz',
    km: 'អស់សង្ឃឹមខ្លាំង',
    pl: 'Bardzo nieszczęśliwy'
  },
  'unhappy': { 
    en: 'Unhappy', 
    th: 'ไม่มีความสุข',
    fr: 'Malheureux',
    pt: 'Infeliz',
    km: 'អស់សង្ឃឹម',
    pl: 'Nieszczęśliwy'
  },
  'happy': { 
    en: 'Happy', 
    th: 'มีความสุข',
    fr: 'Heureux',
    pt: 'Feliz',
    km: 'សប្បាយចិត្ត',
    pl: 'Szczęśliwy'
  },
  'very-happy': { 
    en: 'Very Happy', 
    th: 'มีความสุขมาก',
    fr: 'Très heureux',
    pt: 'Muito feliz',
    km: 'សប្បាយចិត្តខ្លាំង',
    pl: 'Bardzo szczęśliwy'
  },
  'very-negative': { 
    en: 'Very Negative', 
    th: 'แย่มาก',
    fr: 'Très négatif',
    pt: 'Muito negativo',
    km: 'អវិជ្ជមានខ្លាំង',
    pl: 'Bardzo negatywny'
  },
  'negative': { 
    en: 'Negative', 
    th: 'แย่',
    fr: 'Négatif',
    pt: 'Negativo',
    km: 'អវិជ្ជមាន',
    pl: 'Negatywny'
  },
  'positive': { 
    en: 'Positive', 
    th: 'ดี',
    fr: 'Positif',
    pt: 'Positivo',
    km: 'វិជ្ជមាន',
    pl: 'Pozytywny'
  },
  'very-positive': { 
    en: 'Very Positive', 
    th: 'ดีมาก',
    fr: 'Très positif',
    pt: 'Muito positivo',
    km: 'វិជ្ជមានខ្លាំង',
    pl: 'Bardzo pozytywny'
  },
  'very-unlikely': { 
    en: 'Very Unlikely', 
    th: 'ไม่น่าจะเป็นไปได้มาก',
    fr: 'Très improbable',
    pt: 'Muito improvável',
    km: 'មិនអាចកើតមានឡើយ',
    pl: 'Bardzo mało prawdopodobne'
  },
  'unlikely': { 
    en: 'Unlikely', 
    th: 'ไม่น่าจะเป็นไปได้',
    fr: 'Improbable',
    pt: 'Improvável',
    km: 'មិនទំនង',
    pl: 'Mało prawdopodobne'
  },
  'likely': { 
    en: 'Likely', 
    th: 'น่าจะเป็นไปได้',
    fr: 'Probable',
    pt: 'Provável',
    km: 'មានទំនង',
    pl: 'Prawdopodobne'
  },
  'very-likely': { 
    en: 'Very Likely', 
    th: 'เป็นไปได้มาก',
    fr: 'Très probable',
    pt: 'Muito provável',
    km: 'មានទំនងខ្លាំង',
    pl: 'Bardzo prawdopodobne'
  },
  'very-poor': { 
    en: 'Very Poor', 
    th: 'แย่มาก',
    fr: 'Très mauvais',
    pt: 'Muito ruim',
    km: 'អាក្រក់ខ្លាំង',
    pl: 'Bardzo słaby'
  },
  'poor': { 
    en: 'Poor', 
    th: 'แย่',
    fr: 'Mauvais',
    pt: 'Ruim',
    km: 'អាក្រក់',
    pl: 'Słaby'
  },
  'fair': { 
    en: 'Fair', 
    th: 'ปานกลาง',
    fr: 'Passable',
    pt: 'Razoável',
    km: 'មធ្យម',
    pl: 'Średni'
  },
  'good': { 
    en: 'Good', 
    th: 'ดี',
    fr: 'Bon',
    pt: 'Bom',
    km: 'ល្អ',
    pl: 'Dobry'
  },
  'very-good': { 
    en: 'Very Good', 
    th: 'ดีมาก',
    fr: 'Très bon',
    pt: 'Muito bom',
    km: 'ល្អណាស់',
    pl: 'Bardzo dobry'
  },
  'terrible': { 
    en: 'Terrible', 
    th: 'แย่มาก',
    fr: 'Terrible',
    pt: 'Terrível',
    km: 'អាក្រក់ណាស់',
    pl: 'Okropny'
  },
  'bad': { 
    en: 'Bad', 
    th: 'แย่',
    fr: 'Mauvais',
    pt: 'Mau',
    km: 'អាក្រក់',
    pl: 'Zły'
  },
  'okay': { 
    en: 'Okay', 
    th: 'โอเค',
    fr: 'D’accord',
    pt: 'Está bem',
    km: 'អូខេ',
    pl: 'Ok'
  },


  'excellent': { 
    en: 'Excellent', 
    th: 'ยอดเยี่ยม',
    fr: 'Excellent',
    pt: 'Excelente',
    km: 'ល្អឥតខ្ចោះ',
    pl: 'Doskonały'
  },
  'very-easy': { 
    en: 'Very Easy', 
    th: 'ง่ายมาก',
    fr: 'Très facile',
    pt: 'Muito fácil',
    km: 'ងាយស្រួលណាស់',
    pl: 'Bardzo łatwe'
  },
  'easy': { 
    en: 'Easy', 
    th: 'ง่าย',
    fr: 'Facile',
    pt: 'Fácil',
    km: 'ងាយស្រួល',
    pl: 'Łatwe'
  },
  'difficult': { 
    en: 'Difficult', 
    th: 'ยาก',
    fr: 'Difficile',
    pt: 'Difícil',
    km: 'ពិបាក',
    pl: 'Trudne'
  },
  'very-difficult': { 
    en: 'Very Difficult', 
    th: 'ยากมาก',
    fr: 'Très difficile',
    pt: 'Muito difícil',
    km: 'ពិបាកណាស់',
    pl: 'Bardzo trudne'
  },
  'very-slow': { 
    en: 'Very Slow', 
    th: 'ช้ามาก',
    fr: 'Très lent',
    pt: 'Muito lento',
    km: 'យឺតណាស់',
    pl: 'Bardzo wolno'
  },
  'slow': { 
    en: 'Slow', 
    th: 'ช้า',
    fr: 'Lent',
    pt: 'Lento',
    km: 'យឺត',
    pl: 'Wolno'
  },
  'fast': { 
    en: 'Fast', 
    th: 'เร็ว',
    fr: 'Rapide',
    pt: 'Rápido',
    km: 'លឿន',
    pl: 'Szybko'
  },
  'very-fast': { 
    en: 'Very Fast', 
    th: 'เร็วมาก',
    fr: 'Très rapide',
    pt: 'Muito rápido',
    km: 'លឿនណាស់',
    pl: 'Bardzo szybko'
  },
  'very-small': { 
    en: 'Very Small', 
    th: 'เล็กมาก',
    fr: 'Très petit',
    pt: 'Muito pequeno',
    km: 'តូចណាស់',
    pl: 'Bardzo mały'
  },
  'small': { 
    en: 'Small', 
    th: 'เล็ก',
    fr: 'Petit',
    pt: 'Pequeno',
    km: 'តូច',
    pl: 'Mały'
  },
  'medium': { 
    en: 'Medium', 
    th: 'กลาง',
    fr: 'Moyen',
    pt: 'Médio',
    km: 'មធ្យម',
    pl: 'Średni'
  },
  'large': { 
    en: 'Large', 
    th: 'ใหญ่',
    fr: 'Grand',
    pt: 'Grande',
    km: 'ធំ',
    pl: 'Duży'
  },
  'very-large': { 
    en: 'Very Large', 
    th: 'ใหญ่มาก',
    fr: 'Très grand',
    pt: 'Muito grande',
    km: 'ធំណាស់',
    pl: 'Bardzo duży'
  },
  'questions': {
    en : 'Questions',
    th : 'คำถาม',
    fr: 'Questions',
    pt: 'Perguntas',
    km: 'សំណួរ',
    pl: 'Pytania'
  },
  'show-all-types' : {
    en : 'Show All Types',
    th : 'แสดงทุกประเภท',
    fr: 'Afficher tous les types',
    pt: 'Mostrar todos os tipos',
    km: 'បង្ហាញប្រភេទទាំងអស់',
    pl: 'Pokaż wszystkie typy'
  },
  'loading' : {
    en : 'Loading....',
    th : 'กำลังโหลด...',
    fr: 'Chargement....',
    pt: 'Carregando....',
    km: 'កំពុងផ្ទុក....',
    pl: 'Ładowanie....'
  },
  'add-by-id' : {
    en : 'ADD BY ID',
    th : 'เพิ่มโดยรหัส',
    fr: 'AJOUTER PAR ID',
    pt: 'ADICIONAR POR ID',
    km: 'បន្ថែមតាមលេខសម្គាល់',
    pl: 'DODAJ PO ID'
  }
}
